import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotfoundComponent } from './demo/components/notfound/notfound.component';
import { AppLayoutComponent } from './layout/app.layout.component';
import { authGuard } from './auth.guard';
import { loggedInGuard } from './auth/logged-in.guard';
import { pendingAuthStepGuard } from './auth/pending-auth-step.guard';
import { rootRedirectGuard } from './root-redirect.guard';
import { UnauthorizedComponent } from './demo/components/unauthorized/unauthorized.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { ReductionAuthorizationComponent } from './reduction-authorization/reduction-authorization.component';
import { PersonalRequisitionAuthorizationComponent } from './personal-requisition-authorization/personal-requisition-authorization.component';
import { CompaniesModule } from './companies/companies.module';
import { VacationRequestAuthorizationComponent } from './vacation-request-authorization/vacation-request-authorization.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';

@NgModule({
    imports: [
        RouterModule.forRoot(
            [
                {
                    path: '',
                    canActivate: [rootRedirectGuard],
                    children: [],
                },
                {
                    path: 'auth',
                    loadChildren: () =>
                        import('./auth/auth.module').then((m) => m.AuthModule),
                },
                {
                    path: 'home',
                    component: AppLayoutComponent,
                    canActivate: [pendingAuthStepGuard],
                    children: [
                        {
                            path: '',
                            loadChildren: () =>
                                import('./client/client-routing.module').then(
                                    (m) => m.ClientRoutingModule,
                                ),
                        },
                    ],
                },
                {
                    path: 'contacts',
                    component: AppLayoutComponent,
                    canActivate: [pendingAuthStepGuard],
                    loadChildren: () =>
                        import('./client/contacts/contacts.module').then(
                            (m) => m.ContactsModule,
                        ),
                },
                {
                    path: 'admin',
                    component: AppLayoutComponent,
                    canActivate: [pendingAuthStepGuard],
                    children: [
                        {
                            path: '',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./users/users.module').then(
                                    (m) => m.UsersModule,
                                ),
                        },
                        {
                            path: 'area',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./areas/areas.module').then(
                                    (m) => m.AreasModule,
                                ),
                        },
                        {
                            path: 'company',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./companies/companies.module').then(
                                    (m) => m.CompaniesModule,
                                ),
                        },
                        {
                            path: 'department',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./department/department.module').then(
                                    (m) => m.DepartmentModule,
                                ),
                        },
                        {
                            path: 'job_position',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./job-position/job-position.module').then(
                                    (m) => m.JobPositionModule,
                                ),
                        },
                        {
                            path: 'publication',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./publications/publications.module').then(
                                    (m) => m.PublicationsModule,
                                ),
                        },
                        {
                            path: 'event',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./events/events.module').then(
                                    (m) => m.EventsModule,
                                ),
                        },
                        {
                            path: 'evaluations',
                            canActivate: [authGuard],

                            loadChildren: () =>
                                import('./evaluations/evaluations.module').then(
                                    (m) => m.EvaluationsModule,
                                ),
                        },
                        {
                            path: 'organization-chart',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./organization-chart/organization-chart.module').then(
                                    (m) => m.OrganizationChartModule,
                                ),
                        },
                        {
                            path: 'documents',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./documents/documents.module').then(
                                    (m) => m.DocumentsModule,
                                ),
                        },
                        {
                            path: 'normativity',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./normativity/normativity-admin.module').then(
                                    (m) => m.NormativityAdminModule,
                                ),
                        },
                        {
                            path: 'modules',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./modules/modules.module').then(
                                    (m) => m.ModulesModule,
                                ),
                        },
                        {
                            path: 'human-capital',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./human-capital-company/human-capital-company.module').then(
                                    (m) => m.HumanCapitalCompanyModule,
                                ),
                        },
                        {
                            path: 'email-management',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./features/email-management/email-management.module').then(
                                    (m) => m.EmailManagementModule,
                                ),
                        },
                        {
                            path: 'temporal-links',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./temporal-links/temporal-links.module').then(
                                    (m) => m.TemporalLinksModule,
                                ),
                        },
                        {
                             path: 'employee-records',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./employee-records/employee-records.module').then(
                                    (m) => m.EmployeeRecordsModule,),
                        },
                        {
                            path: 'assessments',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./features/assessments/assessments.module').then(
                                    (m) => m.AssessmentsModule,
                                ),
                        },
                        {
                            path: 'user-tenant-permissions',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./user-tenant-permissions/user-tenant-permissions.module').then(
                                    (m) => m.UserTenantPermissionsModule,
                                ),
                        },
                        {
                            path: 'active-sessions',
                            // Página personal: basta con tener sesión (ver loggedInGuard).
                            canActivate: [loggedInGuard],
                            loadChildren: () =>
                                import('./active-sessions/active-sessions.module').then(
                                    (m) => m.ActiveSessionsModule,
                                ),
                        },
                        {
                            path: 'admin-sessions',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./admin-sessions/admin-sessions.module').then(
                                    (m) => m.AdminSessionsModule,
                                ),
                        },
                        {
                            path: 'ceo-admins',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./ceo-admins/ceo-admins.module').then(
                                    (m) => m.CeoAdminsModule,
                                ),
                        },
                        {
                            path: 'security-policies',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./security-policies/security-policies.module').then(
                                    (m) => m.SecurityPoliciesModule,
                                ),
                        },
                        {
                            path: 'app-releases',
                            canActivate: [authGuard],
                            loadChildren: () =>
                                import('./app-releases/app-releases.module').then((m) => m.AppReleasesModule),
                        },
                        {
                            path: 'generations-report',
                            canActivate: [authGuard],
                            loadComponent: () =>
                                import('./users/reports/generations-report/generations-report.component').then(
                                    (c) => c.GenerationsReportComponent
                                ),
                        },
                        {
                            path: 'employee-movement-report',
                            canActivate: [authGuard],
                            loadComponent: () =>
                                import('./users/reports/employee-movement-report/employee-movement-report.component').then(
                                    (c) => c.EmployeeMovementReportComponent
                                ),
                        },
                        // {
                        //     path: 'utilities',
                        //     canActivate: [authGuard],
                        //     loadChildren: () =>
                        //         import(
                        //             './demo/components/utilities/utilities.module'
                        //         ).then((m) => m.UtilitiesModule),
                        // },
                        // {
                        //     path: 'documentation',
                        //     canActivate: [authGuard],
                        //     loadChildren: () =>
                        //         import(
                        //             './demo/components/documentation/documentation.module'
                        //         ).then((m) => m.DocumentationModule),
                        // },
                        // {
                        //     path: 'blocks',
                        //     canActivate: [authGuard],
                        //     loadChildren: () =>
                        //         import(
                        //             './demo/components/primeblocks/primeblocks.module'
                        //         ).then((m) => m.PrimeBlocksModule),
                        // },
                        // {
                        //     path: 'pages',
                        //     canActivate: [authGuard],
                        //     loadChildren: () =>
                        //         import(
                        //             './demo/components/pages/pages.module'
                        //         ).then((m) => m.PagesModule),
                        // },
                    ],
                },
                { path: 'notfound', component: NotfoundComponent },
                { path: 'verify-email', component: VerifyEmailComponent },
                {
                    path: 'reduction-authorization',
                    component: ReductionAuthorizationComponent,
                },
                {
                    path: 'personal-requisition-authorization',
                    component: PersonalRequisitionAuthorizationComponent,
                },
                {
                    path: 'assessment-response',
                    loadChildren: () =>
                        import('./features/assessment-response/assessment-response.module').then(
                            (m) => m.AssessmentResponseModule,
                        ),
                },
                { path: 'unauthorized', component: UnauthorizedComponent },
                {
                    path: 'personal-reductions',
                    loadChildren: () =>
                        import('./client/personal-reductions/personal-reductions.module').then(
                            (m) => m.PersonalReductionsModule,
                        ),
                },
                {
                    path: 'vacation-request-authorization',
                    component: VacationRequestAuthorizationComponent,
                },
                {
                    path: 'privacy-policy',
                    component: PrivacyPolicyComponent,
                },
                {
                    path: 'delete-account',
                    component: DeleteAccountComponent,
                },
                { path: '**', redirectTo: '/notfound' },
            ],
            {
                scrollPositionRestoration: 'enabled',
                anchorScrolling: 'enabled',
                onSameUrlNavigation: 'reload',
            },
        ),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
